import { render, staticRenderFns } from "./Trending.vue?vue&type=template&id=0a6481dd&scoped=true"
import script from "./Trending.vue?vue&type=script&lang=js"
export * from "./Trending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6481dd",
  null
  
)

export default component.exports